import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Card, CardContent, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import api, { SchedulerStatus } from "../../../api";
import { dayjsUtcFormat, durationText, notif } from "../../utils/util";

interface StateRow {
  label: string;
  value: string;
  info?: string;
}

export const SchedulerStatusCard = () => {
  const [status, setStatus] = useState<StateRow[]>([]);

  const loadData = useCallback(async (run: boolean = false) => {
    try {
      const getStatus = async (): Promise<SchedulerStatus> => {
        try {
          if (run) {
            return await api.scheduler.run();
          } else {
            return await api.scheduler.status();
          }
        } catch (err) {
          notif(err, "error");
        }
        return new SchedulerStatus();
      }
      const result = await getStatus();
      const items: StateRow[] = [];
      if (result) {
        items.push({ label: "Time UTC:", value: dayjsUtcFormat(result.currentTime), info: "Scheduler system UTC time" });
        items.push({ label: "Enabled:", value: `${(result.enabled ?? false) ? "Yes": "No" }`, info: "Indicates if scheduler is enabled" });
        items.push({ label: "Running:", value: `${(result.running ?? false) ? "Yes": "No" }`, info: "Indicates if scheduler is currently running" });
        items.push({ label: "Check UTC:", value: dayjsUtcFormat(result.lastCheck), info: "Last time when scheduler check if there are any jobs scheduled for sending" });
        items.push({ label: "Jobs:", value: `${result.forSending ?? 0}`, info: "Total enabled jobs checked in last logged scheduler run" });
        items.push({ label: "Sent:", value: `${result.sent?.length ?? 0}`, info: "Total jobs sent successfuly in last logged scheduler run" });
        items.push({ label: "Failed:", value: `${result.failed?.length ?? 0}`, info: "Total jobs where sending failed in last logged scheduler run" });
        items.push({ label: "Started UTC:", value: dayjsUtcFormat(result.startedAt), info: "Starting UTC time of last logged scheduler run" });
        items.push({ label: "Finished UTC:", value: dayjsUtcFormat(result.finishedAt), info: "Ending UTC time of in last logged scheduler run" });
        if (result.durationSeconds) {
          items.push({ label: "Duration:", value: durationText(result.durationSeconds), info: "Total duration of scheduler run" });
        }
      }
      setStatus(items);
    } catch (err) {
      notif(err, "error");
    }
  }, []);

  const onRefresh = async (event: React.MouseEvent<HTMLElement>) => {
    await loadData();
  };
  const onRun = async (event: React.MouseEvent<HTMLElement>) => {
    await loadData(true);
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Box sx={{ width: 300 }}>
      <Card variant="outlined">
        <CardContent>
          <Typography sx={{ fontSize: 18 }} color="text.primary">
            Last Scheduler Status
          </Typography>
          <Typography component={"span"} sx={{ display: "flex", flexDirection: "column" }} color="text.secondary">
            {status.map((item, index) => (
              <Box sx={{ display: "flex", flexDirection: "row" }} key={index}>
                <Tooltip title={item.info} placement="top-end"><Box sx={{ width: 120, textAlign: "right", paddingRight: 2 }}>{item.label}</Box></Tooltip>
                <Box>{item.value}</Box>
              </Box>
            ))}
            <Stack spacing={2} direction="row" justifyContent="flex-end">
              <IconButton onClick={onRefresh}>
                <RefreshIcon />
              </IconButton>
              <IconButton onClick={onRun}>
                <PlayCircleOutlineIcon />
              </IconButton>
            </Stack>
            <Box sx={{ display: "flex", flexDirection: "row" }} alignItems="end"></Box>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
